/**
 * `useNow` — returns the current Date, ticking every `intervalMs`.
 *
 * Used for SLA timers. INTERACTION_SPEC §4 says timers must update via
 * subscription/diff (no naive re-render). For v1 we accept a 1 s tick:
 * 8 visible tickets × 60 ticks/min = 480 reconciliations/min, which is
 * trivial. Move to a Durable-Object stream + value-tween in v2.
 */

import { useEffect, useState } from 'react';

export function useNow(intervalMs = 1000): Date {
  const [now, setNow] = useState<Date>(() => new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return now;
}
